import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const checkoutImagesUrl = 'https://s3.amazonaws.com/sc-images-checkout/';
const baseUrl = checkoutImagesUrl + 'cc-logo--';

export class CreditCards extends Component {
  render() {
    return (
      <table className="accepted-cards--payment-option">
        <tbody>
          <tr>{this.getAcceptedCards()}</tr>
        </tbody>
      </table>
    );
  }

  getAcceptedCards = () => {
    return Object.keys(this.props.acceptedCards).map((type, i) => {
      return (
        <td key={i} className="cc-type">
          <img
            src={baseUrl + type + '.png'}
            alt={this.props.acceptedCards[type]}
            title={this.props.acceptedCards[type]}
            className={'card-type__' + this.props.acceptedCards[type].replace(/\s+/g, '')}
          />
        </td>
      );
    });
  };
}

CreditCards.propTypes = {
  acceptedCards: PropTypes.object,
};

CreditCards.defaultProps = {
  acceptedCards: {},
};

export default CreditCards;
